import {
  faSquare1,
  faSquare2,
  faSquare3,
  faSquare4,
  faSquare5,
  faSquare6,
} from '@fortawesome/pro-regular-svg-icons'

export const tipsSidePanelData = {
  title: 'Tips for ranking improvement',
  content: [
    {
      icon: faSquare1,
      text: 'Optimize content for top 5 keywords',
    },
    {
      icon: faSquare2,
      text: 'Add all the keywords in the priority sequence in the keywords section',
    },
    {
      icon: faSquare3,
      text: 'Add your main keyword in the product title',
    },
    {
      icon: faSquare4,
      text: 'Add other top keywords under short description, long description and highlights',
    },
    {
      icon: faSquare5,
      text: 'Enable free trial',
      link: ' https://helpcenter.labra.io/hc/en-us/articles/33983569504147-How-to-Add-a-Free-Trial-on-Labra-FlyOut',
    },
    {
      icon: faSquare6,
      text: 'Add vendor insights',
      link: 'https://aws.amazon.com/marketplace/features/vendor-insights/',
    },
  ],
}
